import React from 'react';
import PropTypes from 'prop-types';

const TextInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  const { type, label, placeholder, required } = props;
  return (
    <div className='w-full mb-2'>
      <label className='block uppercase tracking-wide text-gray-700 text-sm font-semibold mb-2'>
        {label}
        {required && <span className='text-red-500 ml-1'>*</span>}
      </label>
      <input
        type={type ? type : 'text'}
        {...field}
        placeholder={placeholder}
        className='block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
      />
      {touched[field.name] && errors[field.name] && (
        <div className='text-xs text-red-500'>{errors[field.name]}</div>
      )}
    </div>
  );
};

TextInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

export default TextInput;
